import {
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../../services/authentication.service';
import { SharedService } from '../../../../services/shared.service';
import { ProfileService } from '../../../shared/ProfileService/profile.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  full_name: string;
  private _mobileQueryListener: () => void;
  status: boolean = false;
  clickEvent() {
    this.status = !this.status;
  }

  subclickEvent() {
    this.status = true;
  }
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public sharedService: SharedService,
    private auth: AuthenticationService,
    public profileService: ProfileService,
    private http: HttpClient,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.profileService.getUserProfile();
  }

  toggleSideNav() {
    if (window.innerWidth < 768) {
      this.sharedService.sideNav.close();
    }
  }

  logout() {
    this.auth.logout();
  }


}
